var mega_menu_button = document.querySelectorAll(".header__inline-menu details-disclosure details");
var mainContentDiv = document.querySelector("#MainContent");

mega_menu_button.forEach(function(list_item) {

  var mega_menu_container = list_item.querySelector(".header__mega-menu-container");
  mega_menu_container.addEventListener("mouseleave", function(){
    list_item.removeAttribute("open",'');
    mainContentDiv.classList.remove("overlay-active");
  });

  list_item.addEventListener("mouseover", function(){
    list_item.setAttribute("open",'');
    mainContentDiv.classList.add("overlay-active");
  });
  list_item.addEventListener("mouseleave", function(){
    list_item.removeAttribute("open",'');
    mainContentDiv.classList.remove("overlay-active");
  });
  

  
});
